import React, { useState } from 'react';
import { Flex, Wrap, WrapItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { countries } from '../../../../../../constants/countries';
import { useInsuredData } from '../../../../../../services/insured-service';
import UseFormMethodsType from '../../../../../../types/UseFormMethodsType';
import InsuredInfoPanel from '../InsuredInfoPanel';

import AddressCard from './AddressCard';
import AddressForm from './AddressForm';

// TODO: some logic represents future state with multiple addresses supported, e.g. hidden AddressCard
const InsuredAddress = ({ onClose, insuredId, useFormMethods, onSubmit }) => {
  const { data: insuredData } = useInsuredData(insuredId);

  const { country, insuredAddress, insuredCity, insuredState, insuredZip } = insuredData;
  const hasAddress = insuredAddress || insuredCity || insuredState || insuredZip;
  const [showForm, toggleAddressForm] = useState(true);
  const [selectedCountry, setCountry] = useState({
    code: country || 'US',
    name: country
      ? countries.find(c => c.code === country)?.name
      : 'United States'
  });

  const { handleSubmit } = useFormMethods;

  const handleClose = () => {
    toggleAddressForm(false);
    onClose();
  };

  return (
    <InsuredInfoPanel
      isDisabled={insuredData?.deletedAt}
      title="insured address"
      onClose={handleClose}
      onSave={handleSubmit(onSubmit)}
    >
      <Flex alignItems="flex-start" direction="column" />

      {!showForm && hasAddress && (
        <Wrap mb="20px" spacing="25px">
          <WrapItem>
            <AddressCard toggleAddressForm={toggleAddressForm} />
          </WrapItem>
        </Wrap>
      )}

      <AddressForm
        visible
        selectedCountry={selectedCountry}
        setCountry={setCountry}
        useFormMethods={useFormMethods}
      />
    </InsuredInfoPanel>
  );
};

InsuredAddress.propTypes = {
  onClose: PropTypes.func,
  insuredId: PropTypes.number.isRequired,
  useFormMethods: UseFormMethodsType
};

export default InsuredAddress;
